import { useDispatch, useSelector } from "react-redux";
import { Store } from "../store/store";
import { Page } from "../api-model/api";
import { NotificationDto } from "../api-model/topbar/notifications";
import { useCallback, useEffect } from "react";
import { getNotifications } from "./notifications";

const NOTIFICATIONS_TIMEOUT = 5 * 60 * 1000; //Min

type UseNotifications = {
  clearNotifications(): void;
  content: NotificationDto[];
  hasUnRead: boolean;
};

export const useNotification = (): UseNotifications => {
  const dispatch = useDispatch();
  const { content } = useSelector<Store, Page<NotificationDto>>(
    (state) => state.notifications.page
  );
  const hasUnRead = content.some((item) => !item.readOrSentAt);
  const clearNotifications = useCallback(() => {
    if (hasUnRead) {
      dispatch(getNotifications(true));
    }
  }, [dispatch, hasUnRead]);

  useEffect(() => {
    let timerId: ReturnType<typeof setTimeout>;

    async function pullNotifications() {
      await dispatch(getNotifications());

      timerId = setTimeout(() => pullNotifications(), NOTIFICATIONS_TIMEOUT);
    }

    pullNotifications();

    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return { clearNotifications, content, hasUnRead };
};
